<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1024 38">
  <g id="xiaobiao6" transform="translate(-0.039 -5)">
    <text id="项目执行人性别分布" transform="translate(0.039 28)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
    <rect id="矩形_2885" data-name="矩形 2885" width="1005" height="1" transform="translate(19.039 41)" fill="var(--theme-color-1)"/>
    <rect id="矩形_2884" data-name="矩形 2884" width="102" height="4" transform="translate(0.039 39)" fill="var(--theme-color-1)"/>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
